const RAW_SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined) || "https://basetaosheet.autos";

export const SITE_ORIGIN = RAW_SITE_URL.replace(/\/+$/, "");